require("./bootstrap");
import "@mdi/font/css/materialdesignicons.css";
import "flag-icons/css/flag-icons.min.css";
import "vuetify/dist/vuetify.min.css";

window.Vue = require("vue");

import Vue from "vue";
import Vuex from "vuex";
import Vuetify from "vuetify";
import VueRouter from "vue-router";
import VueI18n from "vue-i18n";
import Jwt from "jsonwebtoken";

Vue.use(Vuex);
Vue.use(VueRouter);
Vue.use(VueI18n);
Vue.use(Vuetify);

const getDefaultState = () => {
    let token = localStorage.getItem("itb-spa-token");
    let tokenData = token ? Jwt.decode(token) : null;
    return {
        isLoggedIn: false,
        tokenData: tokenData,
        profile: token ? tokenData.user.user : {},
    };
};

const store = new Vuex.Store({
    state: getDefaultState(),
    mutations: {
        authenticate(state, payload) {
            state.isLoggedIn = localStorage.getItem("itb-spa-token")
                ? true
                : false;

            if (state.isLoggedIn) {
                state.profile = payload;
                let token = localStorage.getItem("itb-spa-token");
                state.tokenData = token ? Jwt.decode(token) : null;
            } else {
                state.profile = {};
            }
        },
        resetState(state) {
            state.isLoggedIn = false;
            state.tokenData = null;
            state.profile = {};
        },
    },
    actions: {
        authenticate(context, payload) {
            context.commit("authenticate", payload);
        },
        resetState(context) {
            context.commit("resetState");
        },
    },
});

Vue.component(
    "app-container",
    require("./backend/views/AppContainer.vue").default
);

import Login from "./backend/views/Login.vue";
import ResetPassword from "./backend/views/ResetPassword.vue";
import Error404 from "./backend/views/Error404.vue";
import AdminContainer from "./backend/views/AdminContainer.vue";
import Users from "./backend/views/Users.vue";
import Students from "./backend/views/Students.vue";
import OculusDevices from "./backend/views/OculusDevices.vue";
import Trainings from "./backend/views/Trainings.vue";
import Results from "./backend/views/Results.vue";
import Companies from "./backend/views/Companies.vue";
import Divisions from "./backend/views/Divisions.vue";
import Sections from "./backend/views/Sections.vue";
import Tenants from "./backend/views/Tenants.vue";
import Module from "./backend/views/Module.vue";
import Licenses from "./backend/views/Licenses.vue";
import DownloadApp from "./backend/views/DownloadApp.vue";
import Translation from "./backend/views/Translation.vue";
import Language from "./backend/views/Language.vue";
import ModulesWeb from "./backend/views/ModulesWeb.vue";
import LicencesWeb from "./backend/views/LicencesWeb.vue";
import FAQWeb from "./backend/views/FAQWeb.vue";

const routes = [
    { path: "/login", name: "login", component: Login },
    {
        path: "/obnovit-heslo",
        name: "reset-password",
        component: ResetPassword,
    },
    {
        path: "/admin",
        component: AdminContainer,
        children: [
            { path: "", redirect: "testy" },
            {
                path: "najemce",
                name: "tenants",
                component: Tenants,
                beforeEnter(to, from, next) {
                    const token = localStorage.getItem("itb-spa-token");
                    if (!token) {
                        return;
                    }
                    const tokenData = Jwt.decode(token);

                    if (
                        tokenData.user.user.role === "admin" &&
                        tokenData.user.user.tenant_id === "1"
                    ) {
                        next();
                    } else {
                        next("/404");
                    }
                },
            },
            {
                path: "administratori",
                name: "users",
                component: Users,
                beforeEnter(to, from, next) {
                    const token = localStorage.getItem("itb-spa-token");
                    if (!token) {
                        return;
                    }
                    const tokenData = Jwt.decode(token);

                    if (tokenData.user.user.role === "admin") {
                        next();
                    } else {
                        next("/404");
                    }
                },
            },
            {
                path: "testy",
                name: "trainings",
                component: Trainings,
                beforeEnter(to, from, next) {
                    const token = localStorage.getItem("itb-spa-token");
                    if (!token) {
                        return;
                    }
                    const tokenData = Jwt.decode(token);

                    if (tokenData.user.user.role === "admin") {
                        next();
                    } else {
                        next("/404");
                    }
                },
            },
            {
                path: "vypis-chyb",
                name: "results",
                component: Results,
                beforeEnter(to, from, next) {
                    const token = localStorage.getItem("itb-spa-token");

                    if (!token) {
                        return;
                    }
                    const tokenData = Jwt.decode(token);

                    if (tokenData.user.user.role === "admin") {
                        next();
                    } else {
                        next("/404");
                    }
                },
            },
            {
                path: "ucastnici",
                name: "students",
                component: Students,
                beforeEnter(to, from, next) {
                    const token = localStorage.getItem("itb-spa-token");

                    if (!token) {
                        return;
                    }
                    const tokenData = Jwt.decode(token);

                    if (tokenData.user.user.role === "admin") {
                        next();
                    } else {
                        next("/404");
                    }
                },
            },
            {
                path: "bryle-oculus",
                name: "oculus-devices",
                component: OculusDevices,
                beforeEnter(to, from, next) {
                    const token = localStorage.getItem("itb-spa-token");

                    if (!token) {
                        return;
                    }
                    const tokenData = Jwt.decode(token);

                    if (tokenData.user.user.role === "admin") {
                        next();
                    } else {
                        next("/404");
                    }
                },
            },
            // {
            //     path: "firmy",
            //     name: "companies",
            //     component: Companies,
            //     beforeEnter(to, from, next) {
            //         const token = localStorage.getItem("itb-spa-token");

            //         if (!token) {
            //             return;
            //         }
            //         const tokenData = Jwt.decode(token);

            //         if (tokenData.user.user.role === "admin") {
            //             next();
            //         } else {
            //             next("/404");
            //         }
            //     },
            // },
            {
                path: "divize",
                name: "divisions",
                component: Divisions,
                beforeEnter(to, from, next) {
                    const token = localStorage.getItem("itb-spa-token");

                    if (!token) {
                        return;
                    }
                    const tokenData = Jwt.decode(token);

                    if (tokenData.user.user.role === "admin") {
                        next();
                    } else {
                        next("/404");
                    }
                },
            },
            // {
            //     path: "oddeleni",
            //     name: "sections",
            //     component: Sections,
            //     beforeEnter(to, from, next) {
            //         const token = localStorage.getItem("itb-spa-token");

            //         if (!token) {
            //             return;
            //         }
            //         const tokenData = Jwt.decode(token);

            //         if (tokenData.user.user.role === "admin") {
            //             next();
            //         } else {
            //             next("/404");
            //         }
            //     },
            // },
            {
                path: "moduls",
                name: "modul",
                component: Module,
                beforeEnter(to, from, next) {
                    const token = localStorage.getItem("itb-spa-token");
                    if (!token) {
                        return;
                    }
                    const tokenData = Jwt.decode(token);

                    if (
                        tokenData.user.user.role === "admin" &&
                        tokenData.user.user.tenant_id === "1"
                    ) {
                        next();
                    } else {
                        next("/404");
                    }
                },
            },
            {
                path: "licence",
                name: "licenses",
                component: Licenses,
                beforeEnter(to, from, next) {
                    const token = localStorage.getItem("itb-spa-token");

                    if (!token) {
                        return;
                    }
                    const tokenData = Jwt.decode(token);

                    if (tokenData.user.user.role === "admin") {
                        next();
                    } else {
                        next("/404");
                    }
                },
            },
            {
                path: "aplikace",
                name: "download",
                component: DownloadApp,
                beforeEnter(to, from, next) {
                    const token = localStorage.getItem("itb-spa-token");

                    if (!token) {
                        return;
                    }
                    const tokenData = Jwt.decode(token);

                    if (tokenData.user.user.role === "admin") {
                        next();
                    } else {
                        next("/404");
                    }
                },
            },
            {
                path: "jazyk",
                name: "language",
                component: Language,
                beforeEnter(to, from, next) {
                    const token = localStorage.getItem("itb-spa-token");

                    if (!token) {
                        return;
                    }
                    const tokenData = Jwt.decode(token);

                    if (tokenData.user.user.role === "admin") {
                        next();
                    } else {
                        next("/404");
                    }
                },
            },
            {
                path: "preklad",
                name: "translation",
                component: Translation,
                beforeEnter(to, from, next) {
                    const token = localStorage.getItem("itb-spa-token");

                    if (!token) {
                        return;
                    }
                    const tokenData = Jwt.decode(token);

                    if (tokenData.user.user.role === "admin") {
                        next();
                    } else {
                        next("/404");
                    }
                },
            },
            {
                path: "moduly-web",
                name: "modules_web",
                component: ModulesWeb,
                beforeEnter(to, from, next) {
                    const token = localStorage.getItem("itb-spa-token");

                    if (!token) {
                        return;
                    }
                    const tokenData = Jwt.decode(token);

                    if (tokenData.user.user.role === "admin") {
                        next();
                    } else {
                        next("/404");
                    }
                },
            },
            ,
            {
                path: "licence-web",
                name: "licences_web",
                component: LicencesWeb,
                beforeEnter(to, from, next) {
                    const token = localStorage.getItem("itb-spa-token");

                    if (!token) {
                        return;
                    }
                    const tokenData = Jwt.decode(token);

                    if (tokenData.user.user.role === "admin") {
                        next();
                    } else {
                        next("/404");
                    }
                },
            },
            ,
            {
                path: "faq-web",
                name: "faq_web",
                component: FAQWeb,
                beforeEnter(to, from, next) {
                    const token = localStorage.getItem("itb-spa-token");

                    if (!token) {
                        return;
                    }
                    const tokenData = Jwt.decode(token);

                    if (tokenData.user.user.role === "admin") {
                        next();
                    } else {
                        next("/404");
                    }
                },
            },
        ],
        beforeEnter(to, from, next) {
            const token = localStorage.getItem("itb-spa-token");
            if (token != null) {
                next();
            } else {
                next("/login");
            }
        },
    },
    { path: "*", name: "error404", component: Error404 },
];

const router = new VueRouter({
    mode: "history",
    routes,
});

function loadLocalMessages() {
    const locales = require.context(
        "../../src/locales/backend",
        true,
        /[A-za-z0-9-_,\s]+\.json$/i
    );
    const messages = {};

    locales.keys().forEach((key) => {
        const matched = key.match(/([A-za-z0-9-_]+)\./i);
        if (matched && matched.length > 1) {
            const locale = matched[1];
            messages[locale] = locales(key);
        }
    });

    return messages;
}

const i18n = new VueI18n({
    locale: process.env.VUE_APP_I18N_LOCALE || "cs", //Set locale
    fallbackLocale: process.env.VUE_APP_I18N_FALLBACK_LOCALE || "en", //Set fallback locale
    messages: loadLocalMessages(), //Set locale messages
});

const opts = {
    lang: {
        t: (key, ...params) => i18n.t(key, params),
    },
};

export default new Vuetify(opts);

// Directives
Vue.directive("tr-class-on-hover", {
    bind(el, binding) {
        console.log("tr-class-on-hover binded");
        const { value = "" } = binding;
        el.addEventListener("mouseenter", () => {
            el.closest("tr").classList.add("actions-hover-" + value);
        });
        el.addEventListener("mouseleave", () => {
            el.closest("tr").classList.remove("actions-hover-" + value);
        });
    },
});

const app = new Vue({
    el: "#app",
    vuetify: new Vuetify(),
    i18n,
    router,
    store,
});
